import axios from 'axios';
import { history, store } from '../helpers'
import { Redirect } from "react-router-dom";
import { useDispatch } from "react-redux";
import { logout } from "../actions/authentification";
import AuthentificationService from "../services/authentification.service";
import { LOGOUT, SET_DIALOG } from "../actions/types";

const { dispatch } = store;
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use((response) => {
    return response
}, async function (error) {
    switch (error.response.status) {
        case 401:
            dispatch(logout());
            return history.push('/login')
            break;
        case 404:
            return history.push('/errors/404');
            break;
        case 500:
            return dispatch({
                type: SET_DIALOG,
                payload: {
                    isOpen: true,
                    title: 'Oops! Internal Server Error',
                    message1: 'Sorry, something went wrong on our end.',
                    message2: 'Please contact your administrator'
                }
            });
            break;
        default:
            break;
    }
    return Promise.reject(error);
});
export default axiosInstance;